import { gql } from "@apollo/client";

export const REMOVE_USER = gql`
  mutation removeUser($_id: String!) {
    removeUser(_id: $_id)
  }
`;
